import { render, staticRenderFns } from "./ItemRulesGrid.vue?vue&type=template&id=31239872&scoped=true&"
import script from "./ItemRulesGrid.vue?vue&type=script&lang=js&"
export * from "./ItemRulesGrid.vue?vue&type=script&lang=js&"
import style0 from "./ItemRulesGrid.vue?vue&type=style&index=0&id=31239872&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31239872",
  null
  
)

export default component.exports